/* NeeT: ponasanje zaglavlja (traka, senka pri skrolu, meni brendova, pretraga, bocni meni). */
(function () {
  var nh = document.querySelector('[data-nh]');
  if (!nh) return;

  // Traka: poruke se smenjuju (na desktopu su sve vidljive, pa se smena ne primecuje)
  var poruke = document.querySelectorAll('.nh-traka__poruka');
  if (poruke.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var i = 0;
    setInterval(function () {
      poruke[i].classList.remove('is-on');
      i = (i + 1) % poruke.length;
      poruke[i].classList.add('is-on');
    }, 4000);
  }

  // Senka i manja visina posle skrola
  // prag sa razmakom (60 / 20 px) da stanje ne skace napred-nazad na granici
  var dole = false;
  function skrol() {
    var y = window.scrollY;
    var sada = dole ? y > 20 : y > 60;
    if (sada === dole) return;
    dole = sada;
    nh.classList.toggle('is-skrol', dole);
  }
  window.addEventListener('scroll', skrol, { passive: true });
  skrol();

  // Paneli ispod trake (meni brendova, pretraga): otvoren je najvise jedan
  var mega = nh.querySelector('[data-nh-mega]');
  var megaDugme = nh.querySelector('[data-nh-mega-dugme]');
  var megaStavka = nh.querySelector('[data-nh-mega-stavka]');
  var pretraga = nh.querySelector('[data-nh-pretraga]');
  var pretragaDugme = nh.querySelector('[data-nh-pretraga-dugme]');
  var nalog = nh.querySelector('[data-nh-nalog]');
  var nalogDugme = nh.querySelector('[data-nh-nalog-dugme]');

  function postavi(panel, dugme, otvoren) {
    if (!panel || !dugme) return;
    panel.classList.toggle('is-otvoren', otvoren);
    dugme.setAttribute('aria-expanded', otvoren ? 'true' : 'false');
  }
  function zatvoriSve() {
    postavi(mega, megaDugme, false);
    postavi(pretraga, pretragaDugme, false);
    postavi(nalog, nalogDugme, false);
  }

  if (mega && megaDugme) {
    var tajmer;
    var misIznad = false;
    megaDugme.addEventListener('click', function () {
      // dok je mis iznad, meni je vec otvoren: klik ga ne zatvara
      if (misIznad && mega.classList.contains('is-otvoren')) return;
      var otvori = !mega.classList.contains('is-otvoren');
      zatvoriSve();
      postavi(mega, megaDugme, otvori);
    });
    var fino = window.matchMedia('(hover: hover) and (pointer: fine)');
    [megaStavka, mega].forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        if (!fino.matches) return;
        clearTimeout(tajmer);
        misIznad = true;
        postavi(pretraga, pretragaDugme, false);
        postavi(mega, megaDugme, true);
      });
      el.addEventListener('mouseleave', function () {
        if (!fino.matches) return;
        misIznad = false;
        tajmer = setTimeout(function () { postavi(mega, megaDugme, false); }, 180);
      });
    });
    mega.addEventListener('focusout', function (e) {
      var cilj = e.relatedTarget;
      if (!cilj || (!mega.contains(cilj) && cilj !== megaDugme)) postavi(mega, megaDugme, false);
    });
  }

  if (pretraga && pretragaDugme) {
    pretragaDugme.addEventListener('click', function () {
      var otvori = !pretraga.classList.contains('is-otvoren');
      zatvoriSve();
      postavi(pretraga, pretragaDugme, otvori);
      if (otvori) setTimeout(function () { pretraga.querySelector('input[type="search"]').focus(); }, 60);
    });
  }

  if (nalog && nalogDugme) {
    nalogDugme.addEventListener('click', function () {
      var otvori = !nalog.classList.contains('is-otvoren');
      zatvoriSve();
      postavi(nalog, nalogDugme, otvori);
      if (otvori) { var prvi = nalog.querySelector('a'); if (prvi) setTimeout(function () { prvi.focus(); }, 60); }
    });
    nalog.addEventListener('focusout', function (e) {
      var cilj = e.relatedTarget;
      if (cilj && !nalog.contains(cilj) && cilj !== nalogDugme) postavi(nalog, nalogDugme, false);
    });
  }

  document.addEventListener('click', function (e) {
    if (!nh.contains(e.target)) zatvoriSve();
  });

  // Bocni meni (telefon)
  var meni = document.querySelector('[data-nh-meni]');
  var meniDugme = nh.querySelector('[data-nh-otvori-meni]');
  function otvoriMeni() {
    if (!meni) return;
    meni.hidden = false;
    document.body.classList.add('nh-zakljucano');
    meniDugme.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      meni.classList.add('is-otvoren');
      var prvi = meni.querySelector('[data-nh-zatvori-meni].nh__ikona');
      if (prvi) prvi.focus();
    });
  }
  function zatvoriMeni() {
    if (!meni || meni.hidden) return;
    meni.classList.remove('is-otvoren');
    document.body.classList.remove('nh-zakljucano');
    meniDugme.setAttribute('aria-expanded', 'false');
    setTimeout(function () { meni.hidden = true; }, 320);
    meniDugme.focus();
  }
  if (meni && meniDugme) {
    meniDugme.addEventListener('click', otvoriMeni);
    meni.querySelectorAll('[data-nh-zatvori-meni]').forEach(function (el) { el.addEventListener('click', zatvoriMeni); });
    // fokus ostaje u meniju dok je otvoren
    meni.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = meni.querySelectorAll('a[href], button:not([disabled])');
      var prvi = f[0], zadnji = f[f.length - 1];
      if (e.shiftKey && document.activeElement === prvi) { e.preventDefault(); zadnji.focus(); }
      else if (!e.shiftKey && document.activeElement === zadnji) { e.preventDefault(); prvi.focus(); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (meni && !meni.hidden) return zatvoriMeni();
    var bio = (mega && mega.classList.contains('is-otvoren')) ? megaDugme : (pretraga && pretraga.classList.contains('is-otvoren')) ? pretragaDugme : (nalog && nalog.classList.contains('is-otvoren')) ? nalogDugme : null;
    zatvoriSve();
    if (bio) bio.focus();
  });
})();

/* Pocetna: "Sta ti treba" - dugme potrebe prikazuje karticu svog proizvoda (klik, strelice, mis na desktopu) */
(function () {
  document.querySelectorAll('[data-np-izbor]').forEach(function (koren) {
    var tabovi = Array.prototype.slice.call(koren.querySelectorAll('[data-np-tab]'));
    function izaberi(tab, fokus) {
      tabovi.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) { panel.hidden = !on; panel.classList.toggle('is-on', on); }
      });
      if (fokus) tab.focus();
      if (window.innerWidth < 990) tab.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }
    var fino = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    tabovi.forEach(function (tab, i) {
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.addEventListener('click', function () { izaberi(tab); });
      tab.addEventListener('mouseenter', function () { if (fino.matches) izaberi(tab); });
      tab.addEventListener('keydown', function (e) {
        var k = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
        if (!k) return;
        e.preventDefault();
        izaberi(tabovi[(i + k + tabovi.length) % tabovi.length], true);
      });
    });
  });
})();

/* Kolekcija i stranica proizvoda: "U korpu" bez napustanja strane, kroz Dawn obavestenje o korpi */
(function () {
  document.addEventListener('submit', function (e) {
    var forma = e.target.closest && e.target.closest('.np-karta__forma');
    if (!forma) return;
    var korpa = document.querySelector('cart-notification');
    if (!korpa || typeof fetchConfig !== 'function') return; // bez toga ide obican submit na korpu
    e.preventDefault();
    var dugme = forma.querySelector('button[type="submit"]') || forma.querySelector('button');
    dugme.disabled = true; dugme.setAttribute('aria-busy', 'true');
    var podaci = new FormData(forma);
    podaci.append('sections', korpa.getSectionsToRender().map(function (s) { return s.id; }));
    podaci.append('sections_url', window.location.pathname);
    korpa.setActiveElement(dugme);
    var cfg = fetchConfig('javascript');
    cfg.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete cfg.headers['Content-Type'];
    cfg.body = podaci;
    fetch(window.routes.cart_add_url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (odg) {
        if (odg.status) { window.location.href = forma.action; return; }
        if (document.querySelector('cart-items.np-korpa')) { window.location.reload(); return; }
        korpa.renderContents(odg);
      })
      .catch(function () { forma.submit(); })
      .finally(function () { dugme.disabled = false; dugme.removeAttribute('aria-busy'); });
  });
})();
